import { requirejsOne } from '@ds/swymkit/tools'
import type { UserTagsUtils_AMD } from '@ds/swymkit/typings'

import type { ITag, IUserTag } from '~/features-shared/tags/interfaces/tags'

let UserTagsUtils: UserTagsUtils_AMD

async function init() {
  const module = await requirejsOne<UserTagsUtils_AMD>('DS/TagNavigator/userTags/utils/UserTagsUtils')
  UserTagsUtils = module
}

// Wrapper ensuring non-breakage
function getFilterDescription(t: string | string[]) {
  if (UserTagsUtils?.getFilterDescription)
    return UserTagsUtils.getFilterDescription(t)

  return t
}

// Wrapper ensuring non-breakage
function getFilterPredicate(obj: string | string[], predicate: string | string[]) {
  if (UserTagsUtils?.getFilterPredicate)
    return UserTagsUtils.getFilterPredicate(obj, predicate)

  return predicate
}

/**
 * Function that uses the UserTagsUtils to check if an inline tag is present in the content or not
 *
 * @param tagsList The tags present in tags6w property of a content
 * @param formattedTags The list of inline tags in the content
 */
function setTagsValidity(tagsList: ITag[] | null, formattedTags: IUserTag[]) {
  if (UserTagsUtils?.isAValidTag) {
    const tags = (tagsList || []).map((t) => {
      const tag = Array.isArray(t.tag) ? t.tag : t.tag?.replace('&#47;', '/')
      return {
        ...t,
        tag,
      }
    })
    UserTagsUtils.isAValidTag(tags, formattedTags)
    return
  }

  formattedTags.forEach((tag) => {
    tag.isValid = true
  })
}

export {
  init,
  getFilterDescription,
  getFilterPredicate,
  setTagsValidity,
}
